import React from "react"
import _, { find, isUndefined, get } from "lodash"
import { notification } from "antd"

export default Component => {
  return class WithFormGroupVisibility extends React.Component {
    isFormGroupVisible = formGroupName => {
      const formGroup = find(this.props.formGroups, { name: formGroupName })
      if (isUndefined(formGroup)) return false
      const forms = formGroup.forms

      const isVisible = forms.reduce((isVisible, form) => {
        return (
          isVisible &&
          this.hasFulfilledCondition(form) &&
          this.hasMultiple(form) == 0
        )
      }, true)
      return isVisible
    }

    visibleFormsForFormGroup = formGroupName => {
      const formGroup = find(this.props.formGroups, { name: formGroupName })

      if (isUndefined(formGroup)) return false
      const forms = formGroup.forms

      const visibleForms = forms.reduce((visibleForms, form) => {
        const formMultiple = this.hasMultiple(form)
        return this.hasFulfilledCondition(form) && formMultiple != 0
          ? [
              ...visibleForms,
              ...(formMultiple > 0
                ? new Array(formMultiple)
                    .fill(form.forms._id)
                    .map((formId, index) => [
                      formId,
                      `${this.props.transformFormId(formId)}.${index}`,
                    ])
                : [
                    [
                      form.forms._id,
                      this.props.transformFormId(form.forms._id),
                    ],
                  ]),
            ]
          : visibleForms
      }, [])
      return visibleForms
    }

    hasFulfilledCondition(form) {
      const formReferenceName = `${this.props.transformFormId(
        get(form.condition, "formReference.form._id", "")
      )}.${get(form.condition, "formReference.variable")}`

      let showForm = true

      if (
        form.condition &&
        formReferenceName &&
        get(form.condition, "value") &&
        get(form.condition, "operator")
      ) {
        showForm = evaluateCondition(
          this.props.formData,
          buildCondition(
            formReferenceName,
            get(form.condition, "value"),
            get(form.condition, "operator"),
            this.props.formData
          )
        )
      }
      if (form.conditions) {
        showForm = form.conditions.reduce((showForm, condition) => {
          const formReferenceName = `${this.props.transformFormId(
            get(condition, "formReference.form._id", "")
          )}.${get(condition, "formReference.variable")}`
          return (
            showForm &&
            evaluateCondition(
              this.props.formData,
              buildCondition(
                formReferenceName,
                get(condition, "value"),
                get(condition, "operator"),
                this.props.formData
              )
            )
          )
        }, showForm)
      }
      return showForm
    }

    hasMultiple(form) {
      if (form.multiplier && form.multiplier.form && form.multiplier.variable) {
        try {
          // show form as often as definied in number
          const multiplier = parseInt(
            get(
              this.props.formData,
              `${this.props.transformFormId(
                get(form.multiplier, "form._id", "")
              )}.${get(form.multiplier, "variable", "")}`,
              0
            )
          )

          return multiplier
        } catch (err) {
          if (
            window &&
            ["localhost", "preview.hopkins.systems"].indexOf(
              window.location.hostname
            ) > -1
          ) {
            notification.warning({
              placement: "topRight",
              top: 50,
              duration: 0,
              message: "Problem mit Abhängigkeiten",
              description: `Das ausgewählte Feld ${get(
                form.multiplier,
                "form.name",
                ""
              )} -> ${get(
                form.multiplier,
                "variable",
                ""
              )} ist nicht als Feld für mehrfach anzuzeigende Felder geeignet. Das Formular ${get(
                form,
                "name",
                ""
              )} wird nicht angezeigt `,
            })
          }
        }
      }
      return -1
    }

    render() {
      return (
        <Component
          {...this.props}
          isFormGroupVisible={this.isFormGroupVisible}
          visibleFormsForFormGroup={this.visibleFormsForFormGroup}
        />
      )
    }
  }
}

/*
 ----------------- HELPER ---------------------
**/

function buildCondition(variable, value, [operator], result) {
  const acquiredVariable = get(result, variable)
  if (variable && operator) {
    if (value && result) {
      switch (typeof result[variable]) {
        case "number":
        case "boolean":
          return `"${acquiredVariable}" ${operator} ${value || ""}`
        case "string":
        default:
          return `"${acquiredVariable}" ${operator} "${value || ""}"`
      }
    } else {
      return `typeof ${acquiredVariable} ${operator} "undefined"`
    }
  } else {
    return operator
  }
}

// Although result seems to be unused, it isnt. It is being used in the formed condition
function evaluateCondition(result, condition) {
  let evaluationResult = true
  try {
    // eslint-disable-next-line
    evaluationResult = eval(condition)
  } catch (_error) {
    console.error("Error in evaluation:", condition)
    return false
  }
  return evaluationResult
}
